import React, { createContext, useContext, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TwConfirmDialog, TwNotificationDialog } from "../components/tailwind";
import { TwMessageDialog } from "../components/tailwind/TwDialogs";
import { loadingState } from "../redux/reducers/loadingReducer";

// Create Context
const ToastContext = createContext();

// Toast Provider Component
export const ToastProvider = ({ children }) => {
     const dispatch = useDispatch();
     const loadingReduxState = useSelector(loadingState);

     /**
      * Messages (were toasts). addToast / addSuccessToast / addErrorToast now show a pop-up in the new theme
      * (TwMessageDialog), one at a time; more messages wait in a queue. Success pop-ups close by themselves.
      * option.title sets the pop-up title (default: "Done" / "Something went wrong" / "Good to know").
      */
     const [toasts, setToasts] = useState([]);

     // Function to add a message: default, success, error, info, warning
     const addToast = (message, type = "default", option = {}) => {
          if (message === undefined || message === null || message === "") return;
          const text = typeof message === "string" ? message : message?.message || String(message);
          const id = Date.now() + Math.random();
          setToasts((prev) => {
               // the same message twice in a row (e.g. a double click) shows once
               const last = prev[prev.length - 1];
               if (last && last.message === text && last.type === type) return prev;
               return [...prev, { id, message: text, type, title: option?.title || "" }];
          });
     };

     const addErrorToast = (message, option = {}) => {
          addToast(message, "error", option)
     };

     const addSuccessToast = (message, option = {}) => {
          addToast(message, "success", option)
     };

     // Function to remove a toast
     const removeToast = (id) => {
          setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
     };

     /**
      * Notification Dialog Content
      */

     const defaultNotificationDialogContent = {
          dialogOpen: false,
          dialogType: "info", /** success, error, info, warning **/
          dialogTitle: "",
          dialogMessage: "",
          dialogBtnTitle: "Close",
          isAllowBackdropClick: true,
          isDialogBtnShow: true,
          dialogBtnClick: async () => { closeNotificationDialog() },
     }
     const [notificationDialogContent, setNotificationDialogContent] = useState(defaultNotificationDialogContent)

     const updateNotificationDialog = (name, value) => {
          setNotificationDialogContent((prevValues) => ({
               ...prevValues,
               [name]: value,
          }));
     };

     const addNotificationDialog = (option = defaultNotificationDialogContent) => {
          option.dialogOpen = true;
          Object.keys(option).map((c) => {
               updateNotificationDialog(c, option[c])
               return c
          })
          // setNotificationDialogContent((prevValues) => ({
          //      ...prevValues,
          //      ...option,
          // }));
     };

     const closeNotificationDialog = () => {
          updateNotificationDialog("dialogOpen", false)
     };


     /**
      * Confirm Dialog Content
      */

     const defaultConfirmDialogContent = {
          id: 1,
          dialogOpen: false,
          dialogType: "error", /** success, error, info, warning **/
          dialogTitle: "",
          dialogMessage: "",
          // btnCloseText: "No",
          onClose: async () => { closeNotificationDialog() },
          // btnConfirmText: "Yes",
          onConfirm: async () => { closeNotificationDialog() },
     }

     const [confirmDialogContent, setConfirmDialogContent] = useState([]);

     const addConfirmDialog = (option = defaultConfirmDialogContent) => {
          setTimeout(() => {
               console.log("confirmDialogContent", confirmDialogContent);
               let newlist = [...confirmDialogContent, { ...option, id: (Math.random() * 100) + 1, dialogOpen: true }]
               console.log("newlist", newlist);

               setConfirmDialogContent(newlist);
          }, 1000);
     };
     // addConfirmDialog({
     //      dialogType: "success",
     //      dialogTitle: "Confirm Again",
     //      dialogMessage: "Are you absolutely sure?",
     //      onConfirm: () => {
     //           console.log("Final confirmation received!");
     //      },
     // });

     return (
          <ToastContext.Provider value={{ addToast, addErrorToast, addSuccessToast, addNotificationDialog, closeNotificationDialog, addConfirmDialog }}>
               {children}

               {/* Messages (were toasts): one pop-up at a time */}
               <TwMessageDialog
                    message={toasts.length ? { type: toasts[0].type, title: toasts[0].title, text: toasts[0].message } : null}
                    onClose={() => toasts.length && removeToast(toasts[0].id)}
               />

               <TwNotificationDialog
                    notificationDialogContent={notificationDialogContent}
                    dialogBackdropClick={async () => {
                         if (notificationDialogContent.dialogBackdropClick) {
                              await notificationDialogContent.dialogBackdropClick()
                         } else if (notificationDialogContent.dialogBtnClick) {
                              await notificationDialogContent.dialogBtnClick()
                         } else {
                         }
                         closeNotificationDialog()
                    }}
                    closeNotificationDialog={closeNotificationDialog}
                    setNotificationDialogContent={setNotificationDialogContent}
                    updateNotificationDialog={updateNotificationDialog}
               />
               <div id="confirm-dialog">
                    {confirmDialogContent.map((dialogContent, i) => {
                         // console.log("dialogContent", dialogContent);
                         // console.log("i", i);
                         // return (<>{dialogContent.dialogTitle}</>)
                         return (<TwConfirmDialog
                              key={i}
                              {...dialogContent}
                         // onClose={async () => {
                         //      console.log("close");

                         //      if (dialogContent.onClose) { dialogContent.onClose() }
                         //      // setConfirmDialogContent((prevDialog) => prevDialog.filter((dialog, di) => dialog.id !== dialogContent.id));
                         // }}
                         // onConfirm={async () => {
                         //      if (dialogContent.onConfirm) { dialogContent.onConfirm() }
                         //      // setConfirmDialogContent((prevDialog) => prevDialog.filter((dialog, di) => dialog.id !== dialogContent.id));
                         // }}
                         />)
                    })}
               </div>
          </ToastContext.Provider>
     );
};

// Custom Hook to use Toast
export const useToast = () => {
     return useContext(ToastContext);
};
